import { usePageManager } from 'hooks/pageManager/usePageManager';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const PageRenderer = ({ route }) => {
  const { handleNewPage, skipNextNavigation, pages, activeTabId } =
    usePageManager();
  const { pathname } = useLocation();

  useEffect(() => {
    if (route && route.element) {
      if (skipNextNavigation.current) {
        skipNextNavigation.current = false;
        return;
      }
      handleNewPage({ ...route, href: pathname });
    }
  }, [pathname, route?.path]);

  const children = useMemo(() => {
    return pages.map(p => (
      <div
        key={`${p.id}-${p.refreshVersion ?? 0}`}
        style={{ display: p.id === activeTabId ? '' : 'none' }}
      >
        {p.element}
      </div>
    ));
  }, [pages, activeTabId]);

  return children;
};
